/**
 * @generated SignedSource<<ac8629bbc5f2e1127fe61f068a56a32c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespMarketplaceStickyHeader_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_user">;
  readonly " $fragmentType": "PdpRespMarketplaceStickyHeader_user";
};
export type PdpRespMarketplaceStickyHeader_user$key = {
  readonly " $data"?: PdpRespMarketplaceStickyHeader_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceStickyHeader_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespMarketplaceStickyHeader_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "c13749fb531be7742e9649f05b617a9d";

export default node;
